import React from "react";

import { Button } from "../../../../../components/newUI/button";

type AddContactFormFooterProps = {
  onCancel: () => void;
  submitLabel?: string;
  isSubmitting?: boolean;
};

export const AddContactFormFooter: React.FC<AddContactFormFooterProps> = ({
  onCancel,
  submitLabel = "Create",
  isSubmitting = false,
}) => {
  return (
    <div
      className={
        "flex justify-end gap-3 border-t border-gray-200 bg-white px-6 py-4 text-sm"
      }>
      <Button
        type={"button"}
        size={"sm"}
        variant={"outline"}
        disabled={isSubmitting}
        onClick={onCancel}>
        Cancel
      </Button>
      <Button type={"submit"} size={"sm"} loading={isSubmitting}>
        {submitLabel}
      </Button>
    </div>
  );
};
